import { render, staticRenderFns } from "./userService.vue?vue&type=template&id=0cdc5e61&scoped=true"
import script from "./userService.vue?vue&type=script&lang=js"
export * from "./userService.vue?vue&type=script&lang=js"
import style0 from "./userService.vue?vue&type=style&index=0&id=0cdc5e61&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cdc5e61",
  null
  
)

export default component.exports